var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1136"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 144",
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FF5E5E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 145",
    cx: 26,
    cy: 26,
    r: 15,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartButton);
export default __webpack_public_path__ + "static/media/startButton.bbb7f83ea3430d61c7f8b221fe29a822.svg";
export { ForwardRef as ReactComponent };